import { ModelBase } from 'store/model-base';

export class CmsDeviceCancel extends ModelBase {
    public static storeName: string = 'cmsDeviceCancel';

    public icopTransfer: CmsICOPTransfer;
    public icopGetStarted: CmsICOPGetStarted;
    public canceled: CmsCanceledInfo;
    public accountPinPortOut: CmsAccountPinLineLock;
    public portOutDialog: ResultDialog;
    public fccSimSwapPortOutPin: FccSimSwapPortOut;
    public success: CmsSuccessInfo;
}
